// Build-time endpoints. In production the PWA is served BY the Phoenix server
// (same origin), so both default to the page's own host; `vite dev` falls back
// to the docker-compose defaults. VITE_ vars still override either.

const sameOriginWs = (): string =>
  `${location.protocol === "https:" ? "wss" : "ws"}://${location.host}/v1/realtime`;

export const SERVER_URL: string = (
  import.meta.env.VITE_PHOENIX_SERVER_URL ?? (import.meta.env.DEV ? "http://127.0.0.1:8787" : "")
).replace(/\/+$/, "");

export const VOICE_GATEWAY_URL: string = (
  import.meta.env.VITE_VOICE_GATEWAY_URL ??
  (import.meta.env.DEV ? "ws://127.0.0.1:8000/v1/realtime" : sameOriginWs())
).replace(/\/+$/, "");

export const VOICE_PROFILE = "phoenix.anchor";

const TOKEN_KEY = "phoenix.token";
const TEXTSIZE_KEY = "phoenix.textsize";

export function getToken(): string {
  return localStorage.getItem(TOKEN_KEY) ?? "";
}

export function setToken(token: string): void {
  if (token) localStorage.setItem(TOKEN_KEY, token.trim());
  else localStorage.removeItem(TOKEN_KEY);
}

// ── text size ───────────────────────────────────────────────────────────────
// A device setting, not an account setting: everything is sized in rem, so one
// attribute on <html> scales the whole app (see the shell block in styles.css).

export type TextSize = "normal" | "stor" | "storst";

export function getTextSize(): TextSize {
  const saved = localStorage.getItem(TEXTSIZE_KEY);
  return saved === "stor" || saved === "storst" ? saved : "normal";
}

export function setTextSize(size: TextSize): void {
  localStorage.setItem(TEXTSIZE_KEY, size);
  applyTextSize();
}

export function applyTextSize(): void {
  document.documentElement.setAttribute("data-textsize", getTextSize());
}
